import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../utility/Button';
import ButtonLink from '../utility/ButtonLink';
import PropTypes from 'prop-types';
import VehicleItem from './VehicleItem';
import Dropdown from '../utility/Dropdown';
import LoadingSpinner from '../utility/LoadingSpinner';
import Notification from '../utility/Notification';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import CustomInput from '../utility/CustomInput';
import CustomCheckbox from '../utility/CustomCheckbox';
import Cookies from 'js-cookie';
import TagManager from 'react-gtm-module';

import {
  tShirtTheme,
  NOTIFICATION_DURATION as notificationDuration
} from '../../constants';

import { generateSsoUrl } from '../../actions/auth';

import {
  setBookingStep,
  setBookingFormData,
  setBookingPrimaryDriver,
  setMeetingPoint,
  updateBookingInfo,
  postSaveForLater,
  updateSaveForLater,
  verifyVehicleNo,
  fetchPricingInfo,
  resetByor,
  setVehicleNoAndModel
} from '../../actions/booking';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';
import { Formik, Field, ErrorMessage } from 'formik';

class BookingVehicleSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotification: false,
      submittedVehicleNo: '',
      submittedVehicleModel: '',
      submittedFordRangerOwner: true
    };
    this.handleMeetingPointChange = this.handleMeetingPointChange.bind(this);
    this.saveForLater = this.saveForLater.bind(this);
    this.doShowNotification = this.doShowNotification.bind(this);
    this.generateSso = this.generateSso.bind(this);
    this.nextStep = this.nextStep.bind(this);
  }

  componentDidMount() {
    const { resetByor } = this.props;
    this._isMounted = true;
    resetByor();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleMeetingPointChange(id) {
    const {
      bookingInfo,
      updateBookingInfo,
      match,
      // selectedVehicleId,
      selectedVehicleName,
      setMeetingPoint,
      bookingDate
    } = this.props;
    setMeetingPoint(
      id,
      bookingInfo.meeting_points.find(mp => mp.id === parseInt(id)).name
    );
    updateBookingInfo(
      match.params.slug,
      bookingDate,
      // selectedVehicleId,
      selectedVehicleName,
      parseInt(id)
    );
    window.scrollTo(0, 0);
  }

  saveForLater() {
    this.props.handleSaveForLater(1).then(() => {
      if (!this.state.showNotification && this._isMounted) {
        this.doShowNotification();
      }
    });
  }

  doShowNotification() {
    window.scrollTo(0, 0);
    this.setState(
      {
        showNotification: true
      },
      () => {
        setTimeout(() => {
          if (this._isMounted) {
            this.setState({
              showNotification: false
            });
          }
        }, notificationDuration);
      }
    );
  }

  nextStep(){
    const { setBookingStep } = this.props;
    setBookingStep(2);
    // Send click event to Google Tag Manager
    TagManager.dataLayer({
      dataLayer: {
        event: 'click-next-step1'
      }
    });
  }

  generateSso(method) {
    const { generateSsoUrl } = this.props;

    const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
    generateSsoUrl(method, xsrf);
  }

  render() {
    const { showNotification } = this.state;

    const {
      bookingInfo,
      loading,
      hide,
      setBookingFormData,
      setBookingStep,
      currentTrip,
      savedInfo,
      date,
      handleClick,
      selectedMeetingPointId,
      meetingPointWasReset,
      vehicleWasReset,
      t,
      signedIn,
      saveMessage,
      disableNext,
      byorSelected,
      verifyVehicleNo,
      byorIsMember,
      byorIsMemberLoading,
      bookingPax,
      bookingFormData,
      isByPax,
      fetchPricingInfo,
      resetByor,
      setVehicleNoAndModel,
      slug
    } = this.props;

    console.log('bookingInfo', bookingInfo);
    console.log('state', this.state);
    console.log('byorIsMember', byorIsMember);

    // Test
    // const byorSelected = true;
    return (
      <div className={`col-lg-8 ${hide ? 'fe-hide' : ''}`}>
        {/* {!signedIn ? (
          <div className='fe-booking-signup-promo'>
            <div className='fe-booking-signup-promo-content'>
              <p className='fe-booking-signup-promo-text'>
                {t('form:signUpPromoText')}
              </p>
              <div
                className='fe-u-btnlink'
                style={{ cursor: 'pointer' }}
                onClick={() => this.generateSso('signup')}
              >
                {t('form:signUp')}
              </div>
            </div>
            <div className='fe-booking-signup-promo-img'>
              <div className='fe-u-thumb-16by9'>
                <img src={tShirtTheme[bookingInfo.theme]} alt='' />
              </div>
            </div>
          </div>
        ) : null} */}
        {!loading ? (
          <>
            <Notification show={showNotification}>{saveMessage}</Notification>
            {!byorSelected && (
              <section className='fe-form-meeting-point'>
                <h5 className='fe-form-title'>{t('form:meetingSelection')}</h5>
                <p>{t('form:meetingText')}</p>
                <Dropdown
                  value={selectedMeetingPointId}
                  onChange={this.handleMeetingPointChange}
                  options={bookingInfo.meeting_points.map(mp => mp.name)}
                  optionValues={bookingInfo.meeting_points.map(mp => mp.id)}
                  disabledOptions={bookingInfo.meeting_points.map(
                    mp => !mp.is_available
                  )}
                />
                <div
                  className='fe-form-meeting-point-address'
                  dangerouslySetInnerHTML={{
                    __html: bookingInfo.meeting_points.find(
                      mp => mp.id === selectedMeetingPointId
                    ).address
                  }}
                />
                {meetingPointWasReset ? (
                  <div className='fe-form-error'>
                    {t('form:meetingChanged')}
                  </div>
                ) : null}
              </section>
            )}
            <section className='fe-form-vehicle'>
              {!byorSelected ? (
                <fieldset>
                  <legend className='fe-form-title'>
                    {t('form:vehicleSelection')}
                  </legend>
                  <div className='fe-form-vehicle-selection'>
                    {bookingInfo.vehicle_selection.map(vehicle => (
                      <VehicleItem key={vehicle.id} vehicle={vehicle} />
                    ))}
                  </div>
                </fieldset>
              ) : (
                <>
                  <Formik
                    validateOnChange={true}
                    validateOnBlur={true}
                    initialValues={{
                      vehicleNo: this.state.submittedVehicleNo,
                      fordRangerOwner:  this.state.submittedFordRangerOwner,
                      vehicleModel:  this.state.submittedVehicleModel
                    }}
                    onSubmit={values => {
                      this.setState({submittedVehicleModel: ''});
                      return verifyVehicleNo({
                        vehicleNo: values.vehicleNo,
                        raptorTrip: (currentTrip.slug === 'ford-ranger-sepang-experience-morning-session' || currentTrip.slug === 'ford-ranger-raptor-sepang-experience') ? true : false,
                      }).then(
                        response => {
                          if (response) {
                            this.setState({
                              submittedVehicleNo: values.vehicleNo,
                              submittedVehicleModel: ''
                            });
                            setVehicleNoAndModel(values.vehicleNo, '');
                            fetchPricingInfo(
                              currentTrip.slug || bookingInfo.slug || savedInfo.slug,
                              bookingPax,
                              ...[, ,],
                              isByPax,
                              currentTrip.byor,
                              date
                            );
                          }
                        }
                      );
                    }}
                  >
                    {({ values, handleSubmit, handleBlur }) => (
                      <form onSubmit={handleSubmit} className='fe-form'>
                        <section className='fe-byor-form-section'>
                          <fieldset>
                            <div className='fe-form-field'>

                              <div className={`fe-public-vehicle ${!bookingInfo.is_public && 'fe-hide'}`}>
                                <div className='fe-public-checkbox-field'>
                                  <Field
                                    name='fordRangerOwner'
                                    message={t('form:fordRangerOwner')}
                                    component={CustomCheckbox}
                                    value={this.state.submittedFordRangerOwner}
                                    onClick={e => {
                                      console.log('e.value', e.target.checked);
                                      this.setState({submittedFordRangerOwner: e.target.checked});
                                      resetByor();
                                    }}
                                  />
                                </div>

                                <div className={`${this.state.submittedFordRangerOwner ? 'fe-hide' : ''}`}>
                                  <label htmlFor='vehicleModel'>
                                    {t('form:vehicleModelEx')}
                                  </label>
                                  <div className='fe-public-vehicle-model-field'>
                                    <Field
                                      onKeyUp={e => {
                                        console.log('model value', e.target.value);
                                        this.setState({submittedVehicleModel: e.target.value});
                                      }}
                                      type='text'
                                      name='vehicleModel'
                                      disabled={byorIsMember}
                                      component={CustomInput}
                                      value={this.state.submittedVehicleModel}
                                    />
                                  </div>
                                </div>
                              </div>

                              <label htmlFor='vehicleNo'>
                                {t('form:vehicleNo')}
                              </label>
                              <div className='fe-byor-vehicle-no-field'>
                                <Field
                                  onKeyUp={e => {
                                    console.log('no value', e.target.value);
                                    this.setState({submittedVehicleNo: e.target.value});
                                  }}
                                  onBlur={e => handleBlur(e)}
                                  type='text'
                                  name='vehicleNo'
                                  disabled={byorIsMember}
                                  component={CustomInput}
                                  value={this.state.submittedVehicleNo}
                                />
                                <Button
                                  type='submit'
                                  onClick={() =>
                                    this.setState({ resetError: false })
                                  }
                                  disabled={
                                    byorIsMemberLoading ||
                                    byorIsMember ||
                                    values.vehicleNo.length === 0
                                  }
                                  showLoader={
                                    !byorIsMemberLoading ? false : true
                                  }
                                  className={`${this.state.submittedFordRangerOwner ? '' : 'fe-hide'}`}
                                >
                                  {t('gen:verify')}
                                </Button>
                              </div>
                            </div>
                            {byorIsMember === true && (
                              <span className='fe-form-success'>
                                Registration No. Verified
                              </span>
                            )}
                            {byorIsMember === false && (
                              <span className='fe-form-error'>
                                Vehicle registration number is not a member
                              </span>
                            )}
                          </fieldset>
                        </section>
                      </form>
                    )}
                  </Formik>
                </>
              )}
              {vehicleWasReset ? (
                <div className='fe-form-error'>{t('form:vehicleChanged')}</div>
              ) : null}
            </section>
            <section className='fe-form-insurance'>
              <h5 className='fe-form-title'>{t('form:fordProtectTitle')}</h5>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('form:fordProtectText')
                }}
              />
              {/* <p>{t('form:fordProtectText')}</p> */}
              <a className='fe-link' href='/insurancePolicy_20230331.pdf' target="_blank">
                {t('gen:readMore')}
              </a>
            </section>
            <div className='fe-form-buttons'>
              {byorSelected ? (
                <Button
                  onClick={() => {
                    if (!this.state.submittedFordRangerOwner){
                      fetchPricingInfo(
                        currentTrip.slug || bookingInfo.slug || savedInfo.slug,
                        bookingPax,
                        ...[, ,],
                        isByPax,
                        currentTrip.byor,
                        date
                      ).then(
                        (response) => {
                          console.log('price-processed', response);
                          setVehicleNoAndModel(this.state.submittedVehicleNo, this.state.submittedVehicleModel);
                          this.nextStep();
                        }
                      );
                    }
                    else{
                      this.nextStep();
                    }
                  }}
                  disabled={
                    (
                      this.state.submittedFordRangerOwner &&
                      ( loading || disableNext || !byorIsMember || byorIsMemberLoading )
                    )
                    ||
                      !this.state.submittedFordRangerOwner &&
                      ( !this.state.submittedVehicleNo.length || !this.state.submittedVehicleModel.length)
                  }
                  showLoader={
                    disableNext || !byorIsMember || byorIsMemberLoading
                      ? false
                      : true
                  }
                >
                  {loading ? `${t('gen:loading')}...` : t('gen:next')}
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    this.nextStep();
                  }}
                  disabled={ (this.state.submittedFordRangerOwner && (loading || disableNext)) || !this.state.submittedFordRangerOwner && ( !this.state.submittedVehicleNo.length || !this.state.submittedVehicleModel.length)}
                  showLoader={disableNext ? false : true}
                >
                  {loading ? `${t('gen:loading')}...` : t('gen:next')}
                </Button>
              )}

              <Button alt className='mobile-only' onClick={handleClick}>
                {t('form:changeDate')}
              </Button>
              {/* {signedIn && !showNotification ? (
                <Button
                  className={`borderless ${loading ? 'hide' : ''}`}
                  onClick={this.saveForLater}
                >
                  {t('form:saveDetailsForLater')}
                </Button>
              ) : null} */}
            </div>
          </>
        ) : (
          <LoadingSpinner />
        )}
      </div>
    );
  }
}

BookingVehicleSelection.propTypes = {
  bookingInfo: PropTypes.object.isRequired,
  bookingDate: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  hide: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  setBookingFormData: PropTypes.func.isRequired,
  setBookingPrimaryDriver: PropTypes.func.isRequired,
  setBookingStep: PropTypes.func.isRequired,
  setMeetingPoint: PropTypes.func.isRequired,
  vehicleWasReset: PropTypes.bool.isRequired,
  meetingPointWasReset: PropTypes.bool.isRequired,
  updateBookingInfo: PropTypes.func.isRequired,
  match: PropTypes.object,
  // selectedVehicleId: PropTypes.number.isRequired,
  // selectedMeetingPointId: PropTypes.number.isRequired,
  selectedVehicleName: PropTypes.string.isRequired,
  signedIn: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  postSaveForLater: PropTypes.func.isRequired,
  handleSaveForLater: PropTypes.func.isRequired,
  saveMessage: PropTypes.string.isRequired,
  disableNext: PropTypes.bool.isRequired,
  verifyVehicleNo: PropTypes.func,
  byorIsMemberLoading: PropTypes.bool,
  byorIsMember: PropTypes.bool,
  resetByor: PropTypes.func,
  setVehicleNoAndModel: PropTypes.func,
  fetchPricingInfo: PropTypes.func.isRequired,
  currentTrip: PropTypes.object.isRequired
};

const mapStateToProps = ({ bookingState, authState, tripDetailsState }) => ({
  bookingInfo: bookingState.bookingInfo,
  bookingDate: bookingState.date,
  selectedVehicleName: bookingState.selectedVehicleName,
  // selectedVehicleId: bookingState.selectedVehicleId,
  // selectedMeetingPointId: bookingState.selectedMeetingPointId,
  vehicleWasReset: bookingState.vehicleWasReset,
  meetingPointWasReset: bookingState.meetingPointWasReset,
  loading: bookingState.loading,
  signedIn: authState.signedIn,
  saveMessage: bookingState.saveMessage,
  byorSelected: tripDetailsState.byorSelected,
  byorIsMember: bookingState.byorIsMember,
  byorIsMemberLoading: bookingState.byorIsMemberLoading,
  bookingPax: bookingState.pax,
  isByPax: bookingState.bookingInfo.isByPax,
  currentTrip: tripDetailsState.currentTrip,
  savedInfo: bookingState.savedInfo,
  date: bookingState.date
});

const mapDispatchToProps = {
  setBookingFormData,
  setBookingPrimaryDriver,
  setBookingStep,
  postSaveForLater,
  setMeetingPoint,
  updateBookingInfo,
  updateSaveForLater,
  verifyVehicleNo,
  fetchPricingInfo,
  resetByor,
  generateSsoUrl,
  setVehicleNoAndModel
};

export default withRouter(
  withTranslation()(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BookingVehicleSelection)
  )
);
